// extracted by mini-css-extract-plugin
module.exports = {"blackSign":"black-sign_blackSign__3WYKg","inner":"black-sign_inner__cpDVt"};